<div class="relative min-h-screen">
  <app-header *ngIf="currentUser && currentUser.role !== role.CLIENT" [headerData]="getUserHeaderData()"></app-header>
  <div [class]="currentUser ? 'mt-10' : ''">
    <router-outlet></router-outlet>
  </div>
</div>
